<template>
  <v-app>
    <!--編輯-->
    <v-dialog v-model="dialog" max-width="100%">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap column>
                <v-flex xs12 sm6 md4 v-for="col in dialogKeys" :key="col.value">
                  <div v-if="col.value === 'tradeDate' || col.value === 'tradeBackDate'
                  || col.value === 'sendBackIdDate'">
                    <span class="subheading">{{col.text}}</span>
                    <date-picker :date.sync="editedItem[col.value]" />
                  </div>
                  <v-layout row wrap v-else-if="col.value === 'sealSelf'">
                    <v-switch v-model="editedItem[col.value]" :label="col.text"></v-switch>
                  </v-layout>
                  <v-layout row wrap v-else-if="col.value === 'type'">
                    <v-radio-group v-model="editedItem[col.value]" row>
                      <v-radio label="機車" value="0"></v-radio>
                      <v-radio label="汽車" value="1"></v-radio>
                    </v-radio-group>
                  </v-layout>
                  <v-layout row wrap v-else-if="col.value === 'tradeStatus'">
                    <v-radio-group v-model="editedItem[col.value]" row>
                      <v-radio label="拉車" value="0"></v-radio>
                      <v-radio label="過戶" value="1"></v-radio>
                      <v-radio label="過回" value="1"></v-radio>
                    </v-radio-group>
                  </v-layout>
                  <div v-else-if="col.value === 'address'">
                    <v-text-field v-model="editedItem[col.value]" :label="col.text"
                                  :rules="col.rules"
                                  :disabled="col.disabled"
                                  :required="col.required"></v-text-field>
                  </div>
                  <div v-else-if="col.value === 'creditPrice'">
                    <span class="subheading">期數x期付</span><br/>
                    <v-text-field v-if="isAdmin || isAccounting"
                                  v-model="editedItem[col.value]" :label="col.text"
                                  :rules="col.rules"
                                  :disabled="col.disabled"
                                  :required="col.required"></v-text-field>
                    <span v-else>{{editedItem[col.value]}}</span>
                  </div>
                  <div v-else-if="col.value === 'station'">
                    <span class="red--text subheading">已請示通過免查詢監理站的管轄區</span><br/>
                    <v-text-field
                      v-model="editedItem[col.value]" :label="col.text"
                      :rules="col.rules"
                      :disabled="col.disabled"
                      :required="col.required"></v-text-field>
                  </div>

                  <v-text-field v-else v-model="editedItem[col.value]" :label="col.text"
                                :rules="col.rules"
                                :disabled="col.disabled"
                                :required="col.required"></v-text-field>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn dark color="red darken-1" v-if="isAdmin" @click="removeProfile">刪除</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark color="blue darken-1" @click="closeDialog">取消</v-btn>
            <v-btn class="primary" @click="save"
                   :loading="loading"
                   :disabled="loading">儲存</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <list-editor :column-keys="columnKeys"
                 :items="items"
                 :loading="loading"
                 :showSearchBar="true"
                 :showAddButton="true"
                 :show-export-button="true"
                 :show-search-date="true"
                 :showSearchDate="true"
                 :startDate="searchInfo.startDate"
                 :endDate="searchInfo.endDate"
                 @addData="addData"
                 @editData="edit"
                 @printData="printData"
                 @saveData="save"
                 @removeData="removeData"
                 @searchData="searchData"
                 @exportData="exportData"></list-editor>
    <!--提示-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :show-cancel="true"
                @cancelEvent="messageDialog.cancel"
                @confirmEvent="messageDialog.confirm">
    </alert-view>

    <v-dialog
      v-model="contactDialog.visible"
      persistent
      :max-width="isMobile ? '90%':'40%'">
      <v-card>
        <v-card-title class="headline">
          <p>更改經辦人資料</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-toolbar
                dark
                color="teal">
                <v-toolbar-title>經辦人：</v-toolbar-title>
                <v-autocomplete
                  v-model="selectAgentId"
                  :loading="selectAgentLoading"
                  :items="agentItems"
                  :search-input.sync="searchAgent"
                  cache-items
                  class="mx-4"
                  flat
                  hide-no-data
                  hide-details
                  label="經辦姓名"
                  solo-inverted
                  item-text="displayName"
                  item-value="agentId"
                ></v-autocomplete>
              </v-toolbar>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark text @click="contactDialog.visible = false">取消</v-btn>
          <v-btn class="primary" dark text @click="contactDialog.confirm">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="toolDialog.visible"
      persistent
      :max-width="isMobile ? '90%':'40%'">
      <v-card>
        <v-card-title class="headline">
          {{toolDialog.text}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex>
              <v-btn class="primary" dark text @click="toolEvent(1)">套印</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-btn class="primary" dark text @click="toolEvent(2)">列印</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              <v-btn class="primary" dark text @click="toolEvent(10)">修改經辦人</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark text @click="toolDialog.visible = false">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
import {getNow , exportFileToBlobUrl} from '../utils/tool';
import ListEditor from "../../components/ListEditor";
import dateTimeTool from "../../components/dateTimeTool";
import MobileDetect from 'mobile-detect';
import { mapActions, mapGetters } from 'vuex';
import AlertView from '../../components/AlertView'
import common from '@/mixins/common';
import { getTradeList, removeTradeInfo, saveTradeInfo } from '@/store/actions';
import DatePicker from '@/components/DatePicker.vue';

const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: "TradeCarList",
  components: { DatePicker, ListEditor, dateTimeTool, AlertView},
  data() {
    return {
      cityData: require('../../assets/taiwan_city'),
      cityList: [],
      areaList: {},
      loading: false,
      valid: true,
      dialog: false,
      editedIndex: -1,
      pageIndex: 1,
      limit: 25,
      editedItem: {
        tradeId: Math.uuidFast(),
        type: '',
        engineId: '',
        sellerName:'',
        buyerName:'',
        shippingPrice:0,
        tradeDate: '',
        tradeBackDate: '',
        tradeBackName: '',
        agentId: '',
        agentName: '',
        sendBackIdDate: '',
        sendBackIdPostNumber:'',
        tradeStatus: 0,
        carEngineType: '',
        sealSelf: 0,
        createdDate: getNow(),
        comment :''
      },
      defaultItem:{
        tradeId: Math.uuidFast(),
        type: '',
        engineId: '',
        sellerName:'',
        buyerName:'',
        shippingPrice:0,
        tradeDate: '',
        tradeBackDate: '',
        tradeBackName: '',
        agentId: '',
        agentName: '',
        sendBackIdDate: '',
        sendBackIdPostNumber:'',
        tradeStatus: '',
        carEngineType: '',
        sealSelf: 0,
        createdDate: getNow(),
        comment :''
      },
      messageDialog: {
        title: '',
        text: '',
        visible: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      items:[],
      contactDialog: {
        visible: false,
        confirm:()=>{},
        cancel:()=>{},
      },
      selectAgentLoading:false,
      selectAgentId:null,
      searchAgent:null,
      agentItems:[],
      toolDialog: {
        title: '',
        text: '',
        visible: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },

      searchInfo:{
        startDate:'',
        endDate:'',
        keyword:''
      }
    }
  },
  created(){
    this.cityData.taiwan.forEach((city) => {
      this.cityList.push(city.city);
      this.areaList[city.city] = city.area;
    });
    this.setDefaultDate();
    this.loadData();
  },
  watch:{
    searchAgent(val){
      this.querySelections(val);
    }
  },
  mixins:[common],
  computed: {
    ...mapGetters(['getUserInfo', 'getAgentList']),
    formTitle() {
      return this.editedIndex === -1 ? '新增' : '編輯'
    },
    columnKeys() {
      let list =  [
        // { value: 'delete', text: '刪除', sortable: false  ,required: false},
        { value: 'tools', text: '編輯', sortable: false  ,required: false},
        // { value: 'print', text: '其他工具', sortable: false  ,required: false},
        { value: 'type', text: '車種', sortable: true  ,required: false},
        { value: 'engineId', text: '車號', sortable: true  ,required: false},
        { value: 'sellerName', text: '賣方公司', sortable: false  ,required: false},
        { value: 'buyerName', text: '買方', sortable: true  ,required: false},
        { value: 'shippingPrice', text: '拖車費用', sortable: true  ,required: false},
        { value: 'tradeDate', text: '過戶日期', sortable: true  ,required: false},
        { value: 'tradeBackDate', text: '購回日期', sortable: true  ,required: false},
        { value: 'tradeBackName', text: '購回姓名', sortable: true  ,required: false},
        // { value: 'agentId', text: '經辦人', sortable: true  ,required: false},
        { value: 'agentName', text: '經辦人', sortable: true  ,required: false , disabled: true},
        { value: 'sendBackIdDate', text: '寄回證件日期', sortable: true  ,required: true},
        { value: 'sendBackIdPostNumber', text: '寄回證件郵編', sortable: true  ,required: true},
        { value: 'tradeStatus', text: '狀態', sortable: true  ,required: true },
        { value: 'sealSelf', text: '買方刻印', sortable: true  ,required: true},
        { value: 'createdDate', text: '建立時間', sortable: true  ,required: false , disabled: true },
        { value: 'comment', text: '備註', sortable: false  ,required: false},
      ];
      if (this.isAdmin){
        return list;
      } else {
        return list.filter(m=>m.value !== 'delete');
      }
    },
    dialogKeys() {
      return this.columnKeys.filter(m=>m.value !== 'tools' && m.value !== 'delete' && m.value !== 'print');
    },
  },
  methods: {
    ...mapActions(['getTradeList', 'saveTradeInfo', 'removeTradeInfo','saveContactInfo', 'fetchCreditProductInfo']),
    querySelections (v) {
      this.selectAgentLoading = true
      this.agentItems = this.getAgentList
      this.agentItems = this.getAgentList.filter(e => {
        return (e.displayName || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
      })
      this.selectAgentLoading = false
    },
    setDefaultDate(){
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.searchInfo.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.searchInfo.endDate = `${futureYear}-${futureMonth}-${days}`;
      this.editedItem.startDate = this.searchInfo.startDate;
      this.editedItem.endDate = this.searchInfo.endDate;
    },
    toolEvent(index) {
      if(index === 1)
      {
        let routeData = this.$router.resolve({name: 'MortgageView', query: {profileId: this.editedItem.profileId}});
        window.open(routeData.href, '_blank');
      }else if(index === 2)
      {
        let routeData = this.$router.resolve({name: 'MortgagePrintView', query: {profileId: this.editedItem.profileId}});
        window.open(routeData.href, '_blank');
      }
      else if (index === 10) {
        this.contactDialog.visible = true;

        this.contactDialog.confirm = async ()=>{
          const find = this.getAgentList.find(agent => agent.agentId === this.selectAgentId);
          if (find) {
            this.editedItem.agentId = find.agentId;
            this.loading = true;

            try {
              const res = await this.saveTradeInfo(this.editedItem);
              const result = res.data;
              console.log(`saveTradeInfo = ${JSON.stringify(result)}`);
              if (result.statusCode === 0){
                this.loadData();
                this.dialog.visible = false;
              }
            } catch (e) {
              console.log(`saveTradeInfo error === `, e)
            } finally {
              this.loading = false;
            }
            // console.log(`change agent === ${JSON.stringify(this.editedItem)}`);
          }
        }
      }
    },
    async changeContact(data){
      const result = await this.saveContactInfo(data);
      this.loadData();
      console.log(`result === ${JSON.stringify(result)}`);
    },
    async loadData(){
      this.loading = true;
      const beginDate = `${this.searchInfo.startDate}`
      const tempEndDate = `${this.searchInfo.endDate}`
      let searchQuery = [];
      if (this.searchKey && this.searchValue) {
        searchQuery.push({
          key: `${this.searchKey}`,
          value: `${this.searchValue}`,
        });
      }

      console.log(`beginDate === ${beginDate} tempEndDate === ${tempEndDate}`)
       try {
         const results = await this.getTradeList({
           agentId: (this.isAdmin || this.isTimeAdmin) ? "" : this.getUserInfo.agentId,
           startDate: beginDate,
           endDate: tempEndDate,
           pageIndex: this.pageIndex,
           limit: this.limit,
           searchQuery: searchQuery
         });
         this.items = results.data.data.list;
         this.totalItems = results.data.data.header.totalCount;

       } catch (e) {
         console.log(`result === ` ,e );
       } finally {
         this.loading = false;
       }
    },
    addData(){
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.dialog = true;
      console.log(`addData ${JSON.stringify(this.editedItem)}`);
    },
    async save() {
      if (this.$refs.form.validate()) {

        this.editedItem.agentId = this.getUserInfo.agentId;
        this.editedItem.agentName = this.getUserInfo.displayName;

        this.loading = true;
        try {
          const res = await this.saveTradeInfo(this.editedItem);
          const result = res.data;
          if (result.statusCode === 0){
            this.loadData();
            this.dialog = false;
          }
        } catch (e) {
          console.log(`saveTradeInfo error === `, e)
        } finally {
          this.loading = false;
        }
      }
    },
    edit(item){
      this.editedItem = item;
      console.log(`edit == ${JSON.stringify(item)}`);
      this.dialog = true;
      this.editedIndex = 0;
    },
    removeData(item){
      this.showMessageDialog('提示', '是否確定要刪除？', true, ()=>{
        this.deleteTradeInfo(this.editedItem.tradeId);
      } , ()=>{
      });
    },
    async printData(item) {
      this.editedItem = item;
      this.toolDialog.visible = true;
    },
    searchData(search){
      console.log(`searchData ${JSON.stringify(search)}`);
      this.searchInfo.startDate = search.startDate
      this.searchInfo.endDate = search.endDate;
      this.searchInfo.keyword = search.keyword;
      this.loadData();
      // if (search.keyword !=='' || search.searchDate.length > 0){
      //     this.items = this.items.filter(item=>{
      //         const value = `${item.memberId}${item.name}${item.carId}`;
      //         if (search.searchDate && search.searchDate.length > 0) {
      //             const date1 = new Date(`${search.searchDate[0]} 00:00:00`).getTime();
      //             const date2 = new Date(`${search.searchDate[1]} 23:59:59`).getTime();
      //             const itemDate = new Date(item.createDate).getTime();

      //             if (search.keyword !=='') {
      //                 return value.indexOf(search.keyword) > -1 && (itemDate >= date1 && itemDate <= date2);
      //             } else {
      //                 return (itemDate >= date1 && itemDate <= date2);
      //             }
      //         }
      //         if (search.keyword !=='') {
      //             return value.indexOf(search.keyword) > -1;
      //         }
      //     })
      // } else {
      //     this.loadData();
      // }
    },
    sortSearchKeyword(){
      const keyWord = this.searchInfo.keyword ? this.searchInfo.keyword.trim() : '';
      if (keyWord){
        this.items = this.items.filter(item=>{
          const value = `${item.memberId}${item.name}${item.carId}`;
          if (this.searchInfo.keyword !=='') {
            return value.indexOf(this.searchInfo.keyword) > -1;
          }
        })
      }
    },
    removeProfile(){
      this.showMessageDialog('提示', '是否確定要刪除？', true, ()=>{
        this.deleteTradeInfo(this.editedItem.tradeId);
      } , ()=>{
      });
    },
    async deleteTradeInfo(tradeId){
      try{
        const res = await this.removeTradeInfo({ tradeId });
        const result = res.data;
        if (result.statusCode === 0){
          this.loadData();
          this.closeDialog();
        }
      } catch (e) {
        console.log(`delete error` , e);
        this.showMessageDialog('錯誤', '刪除失敗', true);
      }
    },
    closeDialog(){
      this.loading = false;
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.loadData();
    },
    exportData(){
      let list = this.items;
      const columns = [
        { name: '經銷', key: 'parentAgentName' },
        { name: '身分證/統一編號', key: 'memberId' },
        { name: '車主名稱', key: 'name' },
        { name: '出生日期', key: 'birthday' },
        { name: '車主名稱', key: 'name' },
        { name: '縣市', key: 'city' },
        { name: '戶籍地址', key: 'address' },
        { name: '契約生效日', key: 'startDate' },
        { name: '契約終止日', key: 'endDate' },
        { name: '期數x期付', key: 'creditPrice' },
        { name: '監理所', key: 'station' },
        { name: '牌照號碼', key: 'carId' },
        { name: '廠牌', key: 'vendorId' },
        { name: '出廠年份', key: 'carYear' },
        { name: '引擎號碼/車身號碼', key: 'engineId' },
        { name: '牌照類別', key: 'carType' },
        { name: '型式', key: 'carEngineType' },
        { name: '建立時間', key: 'createDate' },
        { name: '備註', key: 'comment' },
      ];
      exportFileToBlobUrl('動產抵押申請資料匯出', columns , list);
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/TradeCarList.vue